import { render, staticRenderFns } from "./vc_botao_adiciona.vue?vue&type=template&id=1fd99f7f&"
import script from "./vc_botao_adiciona.vue?vue&type=script&lang=js&"
export * from "./vc_botao_adiciona.vue?vue&type=script&lang=js&"
import style0 from "./vc_botao_adiciona.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports